// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as OrderReviewQueryParams$PorterinFeature from "../../containers/order-review/domain/entity/OrderReviewQueryParams.mjs";

function defaultValue_set_query_params(param) {
  
}

var defaultValue_is_valid_params = {
  TAG: /* Loading */0,
  _0: undefined
};

function defaultValue_set_geo_region_id(param) {
  
}

function defaultValue_set_is_retry(param) {
  
}

function defaultValue_set_is_create_trip_retry(param) {
  
}

function defaultValue_set_selected_vehicle(param) {
  
}

function defaultValue_set_selected_vehicle_fare(param) {
  
}

function defaultValue_set_selected_goods_type(param) {
  
}

function defaultValue_set_location_bound(param) {
  
}

function defaultValue_set_restriction_bound(param) {
  
}

function defaultValue_set_vehicle_details(param) {
  
}

var defaultValue_restricted_vehicles = [];

function defaultValue_set_restricted_vehicles(param) {
  
}

function defaultValue_set_quotation(param) {
  
}

function defaultValue_set_vehicles_result(param) {
  
}

function defaultValue_set_disabled_trip_creation(param) {
  
}

var defaultValue = {
  query_params: OrderReviewQueryParams$PorterinFeature.getDefault,
  set_query_params: defaultValue_set_query_params,
  is_valid_params: defaultValue_is_valid_params,
  geo_region_id: undefined,
  set_geo_region_id: defaultValue_set_geo_region_id,
  is_retry: false,
  set_is_retry: defaultValue_set_is_retry,
  is_create_trip_retry: false,
  set_is_create_trip_retry: defaultValue_set_is_create_trip_retry,
  selected_vehicle: 0,
  set_selected_vehicle: defaultValue_set_selected_vehicle,
  selected_vehicle_fare: "0",
  set_selected_vehicle_fare: defaultValue_set_selected_vehicle_fare,
  selected_goods_type: undefined,
  set_selected_goods_type: defaultValue_set_selected_goods_type,
  customer_details: /* Init */0,
  location_bound: undefined,
  set_location_bound: defaultValue_set_location_bound,
  restriction_bound: undefined,
  set_restriction_bound: defaultValue_set_restriction_bound,
  vehicle_details: undefined,
  set_vehicle_details: defaultValue_set_vehicle_details,
  restricted_vehicles: defaultValue_restricted_vehicles,
  set_restricted_vehicles: defaultValue_set_restricted_vehicles,
  quotation: undefined,
  set_quotation: defaultValue_set_quotation,
  vehicle_results: undefined,
  set_vehicles_result: defaultValue_set_vehicles_result,
  disabled_trip_creation: false,
  set_disabled_trip_creation: defaultValue_set_disabled_trip_creation
};

var context = React.createContext(defaultValue);

function useOrderReviewContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useOrderReviewContext ,
}
/* context Not a pure module */
